import { render, staticRenderFns } from "./RecurringOrders.vue?vue&type=template&id=dc5f14f2&"
import script from "./RecurringOrders.vue?vue&type=script&lang=js&"
export * from "./RecurringOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports